<div class="checklist-definition-mat-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="checklistDefinitionIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "checklistdefinition.ui.assignment.header" | translate }}
      </div>
    </span>
  </div>
  <div class="checklist-definition-mat-dialog-body">
    <!--Search Side Bar-->
    <div class="flex-2 left">
      <ng-bee-list
        [focusElement]="true"
        [isMaterialIcon]="true"
        [icon]="checklistDefinitionIcon"
        name="CHECKLIST_DEFINITION"
        [columns]="columns"
        (filterChange)="onFilterChange($event)"
      >
        <div class="no-data" *ngIf="resultsLength === 0">
          {{ "app.nodata.label" | translate }}
        </div>

        <mat-table class="data-table" #table [dataSource]="dataSource" matSort>
          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <mat-header-cell
              class="image-cell"
              *matHeaderCellDef
            ></mat-header-cell>
            <mat-cell class="image-cell" *matCellDef="let row">
              <mat-icon [innerHTML]="checklistDefinitionIcon"></mat-icon>
            </mat-cell>
          </ng-container>

          <!-- fullName Column -->
          <ng-container *ngFor="let column of columns">
            <ng-container
              *ngIf="column.isModelProperty"
              [matColumnDef]="column.property"
            >
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ column.name | translate }}</mat-header-cell
              >
              <mat-cell *matCellDef="let row">
                <div class="html-overflow" style="max-width: 410px">
                  {{ row[column.property] }}
                </div>
              </mat-cell>
            </ng-container>
          </ng-container>

          <mat-row
            *matRowDef="let row; columns: visibleColumns"
            (click)="selectChecklistDefinition(row)"
            (keydown.enter)="selectChecklistDefinition(row)"
            [ngClass]="{
              'selected-checklist-definition':
                checklistDefinitionId && row.id === checklistDefinitionId,
            }"
          >
          </mat-row>
        </mat-table>
        <mat-paginator
          class="paginator wh-equipment-node-paginator"
          hidePageSize
          [length]="resultsLength"
          [pageSize]="pageSize"
        >
        </mat-paginator>
      </ng-bee-list>
    </div>
    <!-- Checklist Definition Selector-->
    <div class="flex-6 right">
      <div class="checklists-wrapper flex-1">
        @if (checklistDefinitionId) {
          <div>
            <ng-bee-checklist-definition-detail
              class="checklist-definition-mat-dialog-checklist-definition-detail"
              [displayHeader]="false"
              [displayHeaderInBody]="true"
              [displayActionButtons]="false"
            >
            </ng-bee-checklist-definition-detail>
          </div>
        } @else if (!checklistDefinitionId) {
          <div class="select-checklist-definition-msg">
            <span whFlex style="align-self: center">
              {{
                "workstep.ui.selectchecklistdefinition.helpertext" | translate
              }}
            </span>
          </div>
        }
      </div>
      <div class="flex--r-c-fe gap--8 p--16">
        <w-h-button
          [text]="'app.cancel.label' | translate | uppercase"
          matIcon="close"
          type="stroked"
          (clicked)="cancel()"
        />
        <w-h-button
          *ngIf="isAssignable"
          [text]="'app.assign.label' | translate | uppercase"
          matIcon="save"
          color="accent"
          type="flat"
          [disabled]="
            !checklistDefinitionId || data?.calculatedWorkStepStatusId > 0
          "
          (clicked)="assignChecklistDefinition()"
        />
      </div>
    </div>
  </div>
</div>
